import { render, staticRenderFns } from "./Stage4.vue?vue&type=template&id=6cbfcb1a&scoped=true&"
import script from "./Stage4.vue?vue&type=script&lang=js&"
export * from "./Stage4.vue?vue&type=script&lang=js&"
import style0 from "./Stage4.vue?vue&type=style&index=0&id=6cbfcb1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbfcb1a",
  null
  
)

export default component.exports